import React from 'react';
import {Modal, Button} from 'react-bootstrap';
import './modalComponent.scss';

const ModalComponent = ({title, message, show, handleClose, handleOk, handleCancel, okBtn = 'ok', closeBtn}) => {
  return (
    <Modal show={show} onHide={handleClose} centered="true" className="modal-component" >
      <Modal.Header>
        <Modal.Title centered="true">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body centered="true">{message}</Modal.Body>
      <Modal.Footer>        
        <Button variant="primary" onClick={handleOk}>
          {okBtn}
        </Button>
        {closeBtn ? (
          <Button variant="secondary" onClick={handleCancel}>
            {closeBtn}
          </Button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalComponent;
